import styled from 'styled-components';
import { SELECTORS } from '../../../constants';

export const StarterPackFullSvg = styled.div`
    ${SELECTORS} & {
        width: 100%;
        height: 100%;
        position: relative;
      
        svg {
            display: block;
            margin: auto;
            
            path,
            ellipse {
                fill: white !important;
            }
        }
        img{
          display: block;
            margin: auto;
        }
    }
`;

interface IDescriptionItemProps {
    isActive: boolean;
    theme: any;
}

export const IconWrapper = styled.div`
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: ${(props: IDescriptionItemProps) => props.isActive ? "translate(-50%, -50%)" : "translate(-50%, -45%)"};
    transition: .2s all ease-in-out;
    visibility: ${(props: IDescriptionItemProps) => props.isActive ? "visible" : "hidden"};
    opacity: ${(props: IDescriptionItemProps) => props.isActive ? "1" : "0"};
`;
